import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-data-deletion-page',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './data-deletion-page.component.html',
  styleUrl: './data-deletion-page.component.scss',
})
export class DataDeletionPageComponent {}
